"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptReservation = acceptReservation;
exports.amenitiesByAmenity = amenitiesByAmenity;
exports.amenitiesByDay = amenitiesByDay;
exports.amenityAbility = amenityAbility;
exports.amenityWatcher = amenityWatcher;
exports.blockAmenity = blockAmenity;
exports.checkout = checkout;
exports.create = create;
exports.createReservation = createReservation;
exports.debitStock = debitStock;
exports.deleteAmenity = deleteAmenity;
exports.deleteReservation = deleteReservation;
exports.edit = edit;
exports.editReservation = editReservation;
exports.finishEntry = finishEntry;
exports.generateLostStockReport = generateLostStockReport;
exports.get = get;
exports.list = list;
exports.listAcceptedReservations = listAcceptedReservations;
exports.listBlocks = listBlocks;
exports.listDayAvailability = listDayAvailability;
exports.listEntries = listEntries;
exports.listMonthAvailability = listMonthAvailability;
exports.listPendentCheckouts = listPendentCheckouts;
exports.listPendingReservations = listPendingReservations;
exports.listReservationEndPeriods = listReservationEndPeriods;
exports.listReservations = listReservations;
exports.listStockMovement = listStockMovement;
exports.rejectReservation = rejectReservation;
exports.replenishStock = replenishStock;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../variables");
var _helpers = require("@qwkin/helpers");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(amenityWatcher);
function amenitiesByAmenity(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.AmenityService.amenitiesUsageByAmenity, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.AMENITIES_USAGE_BY_AMENITY_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 16;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 13;
          return (0, _effects.put)({
            type: _variables.AMENITIES_USAGE_BY_AMENITY_FAIL,
            payload: _response
          });
        case 13:
          _context.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 15:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })();
}
function amenitiesByDay(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.AmenityService.amenitiesUsageByDay, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.AMENITIES_USAGE_BY_DAY_SUCCESS,
            payload: response
          });
        case 6:
          _context2.next = 16;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 13;
          return (0, _effects.put)({
            type: _variables.AMENITIES_USAGE_BY_DAY_FAIL,
            payload: _response2
          });
        case 13:
          _context2.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 15:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  })();
}
function checkout(_ref5) {
  var payload = _ref5.payload,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? _helpers.identity : _ref5$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.AmenityService.checkout, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.CHECKOUT_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context3.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Checkout success'
            }
          });
        case 9:
          _context3.next = 19;
          break;
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 16;
          return (0, _effects.put)({
            type: _variables.CHECKOUT_FAIL,
            payload: _response3
          });
        case 16:
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 18:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 11]]);
  })();
}
function finishEntry(_ref7) {
  var payload = _ref7.payload,
    _ref7$callback = _ref7.callback,
    callback = _ref7$callback === void 0 ? _helpers.identity : _ref7$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.AmenityService.finishEntry, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.FINISH_AMENITY_ENTRY_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context4.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Entry finished with success'
            }
          });
        case 9:
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables.FINISH_AMENITY_ENTRY_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function blockAmenity(_ref9) {
  var payload = _ref9.payload,
    _ref9$callback = _ref9.callback,
    callback = _ref9$callback === void 0 ? _helpers.identity : _ref9$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.AmenityService.blockAmenity, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables.BLOCK_AMENITY_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context5.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Block amenity success'
            }
          });
        case 9:
          _context5.next = 19;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 16;
          return (0, _effects.put)({
            type: _variables.BLOCK_AMENITY_FAIL,
            payload: _response5
          });
        case 16:
          _context5.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 18:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 11]]);
  })();
}
function listEntries(_ref11) {
  var payload = _ref11.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.AmenityService.listAmenitiesEntries, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_ENTRIES_SUCCESS,
            payload: response
          });
        case 6:
          _context6.next = 16;
          break;
        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](0);
          _response6 = _context6.t0.response;
          _context6.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_ENTRIES_FAIL,
            payload: _response6
          });
        case 13:
          _context6.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 15:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 16:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 8]]);
  })();
}
function listBlocks(_ref13) {
  var payload = _ref13.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var response, _response7$data, _response7$data2, _response7;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.AmenityService.listAmenitiesEntries, payload);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_BLOCKS_SUCCESS,
            payload: response
          });
        case 6:
          _context7.next = 16;
          break;
        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](0);
          _response7 = _context7.t0.response;
          _context7.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_BLOCKS_FAIL,
            payload: _response7
          });
        case 13:
          _context7.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response7$data = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data !== void 0 ? _response7$data : {}),
              data: _response7
            }
          });
        case 15:
          (0, _utils.logErr)((_response7$data2 = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data2 !== void 0 ? _response7$data2 : {});
        case 16:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 8]]);
  })();
}
function listStockMovement(_ref15) {
  var payload = _ref15.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var response, _response8$data, _response8$data2, _response8;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.AmenityService.listAmenitiesStockMovements, payload);
        case 3:
          response = _context8.sent;
          _context8.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_STOCK_MOVEMENT_SUCCESS,
            payload: response
          });
        case 6:
          _context8.next = 16;
          break;
        case 8:
          _context8.prev = 8;
          _context8.t0 = _context8["catch"](0);
          _response8 = _context8.t0.response;
          _context8.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_STOCK_MOVEMENT_FAIL,
            payload: _response8
          });
        case 13:
          _context8.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response8$data = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data !== void 0 ? _response8$data : {}),
              data: _response8
            }
          });
        case 15:
          (0, _utils.logErr)((_response8$data2 = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data2 !== void 0 ? _response8$data2 : {});
        case 16:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 8]]);
  })();
}
function listPendentCheckouts(_ref17) {
  var payload = _ref17.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var response, _response9$data, _response9$data2, _response9;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.AmenityService.listPendingCheckouts, payload);
        case 3:
          response = _context9.sent;
          _context9.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_PENDENT_CHECKOUTS_SUCCESS,
            payload: response
          });
        case 6:
          _context9.next = 16;
          break;
        case 8:
          _context9.prev = 8;
          _context9.t0 = _context9["catch"](0);
          _response9 = _context9.t0.response;
          _context9.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_PENDENT_CHECKOUTS_FAIL,
            payload: _response9
          });
        case 13:
          _context9.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response9$data = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data !== void 0 ? _response9$data : {}),
              data: _response9
            }
          });
        case 15:
          (0, _utils.logErr)((_response9$data2 = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data2 !== void 0 ? _response9$data2 : {});
        case 16:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 8]]);
  })();
}
function listDayAvailability(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
    var response, _response10$data, _response10;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.AmenityService.getDayAvailability, payload);
        case 3:
          response = _context10.sent;
          _context10.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_DAY_AVAILABILITY_SUCCESS,
            payload: response
          });
        case 6:
          _context10.next = 14;
          break;
        case 8:
          _context10.prev = 8;
          _context10.t0 = _context10["catch"](0);
          _response10 = _context10.t0.response;
          _context10.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_DAY_AVAILABILITY_FAIL,
            payload: _response10
          });
        case 13:
          // yield put({ type: NOTIFY, payload: { variant: 'error', message: getErrorMsg(response?.data ?? {}), data: response } });
          (0, _utils.logErr)((_response10$data = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data !== void 0 ? _response10$data : {});
        case 14:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 8]]);
  })();
}
function listMonthAvailability(_ref21) {
  var payload = _ref21.payload,
    _ref21$callback = _ref21.callback,
    callback = _ref21$callback === void 0 ? _helpers.identity : _ref21$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var response, _response11$data, _response11$data2, _response11;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.AmenityService.getMonthAvailability, payload);
        case 3:
          response = _context11.sent;
          _context11.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_MONTH_AVAILABILITY_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context11.next = 17;
          break;
        case 9:
          _context11.prev = 9;
          _context11.t0 = _context11["catch"](0);
          _response11 = _context11.t0.response;
          _context11.next = 14;
          return (0, _effects.put)({
            type: _variables.GET_MONTH_AVAILABILITY_FAIL,
            payload: _response11
          });
        case 14:
          _context11.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response11$data = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data !== void 0 ? _response11$data : {}),
              data: _response11
            }
          });
        case 16:
          (0, _utils.logErr)((_response11$data2 = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data2 !== void 0 ? _response11$data2 : {});
        case 17:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 9]]);
  })();
}
function listReservationEndPeriods(_ref23) {
  var payload = _ref23.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var response, _response12$data, _response12$data2, _response12;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.AmenityService.getReservationEndPeriods, payload);
        case 3:
          response = _context12.sent;
          _context12.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_RESERVATION_END_PERIODS_SUCCESS,
            payload: response
          });
        case 6:
          _context12.next = 16;
          break;
        case 8:
          _context12.prev = 8;
          _context12.t0 = _context12["catch"](0);
          _response12 = _context12.t0.response;
          _context12.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_RESERVATION_END_PERIODS_FAIL,
            payload: _response12
          });
        case 13:
          _context12.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response12$data = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data !== void 0 ? _response12$data : {}),
              data: _response12
            }
          });
        case 15:
          (0, _utils.logErr)((_response12$data2 = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data2 !== void 0 ? _response12$data2 : {});
        case 16:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 8]]);
  })();
}
function createReservation(_ref25) {
  var payload = _ref25.payload,
    _ref25$callback = _ref25.callback,
    callback = _ref25$callback === void 0 ? _helpers.identity : _ref25$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
    var response, _response13$data, _response13$data2, _response13;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.AmenityService.createAdminReservation, payload);
        case 3:
          response = _context13.sent;
          _context13.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_AMENITY_RESERVATION_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context13.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Reservation created successfully'
            }
          });
        case 9:
          _context13.next = 19;
          break;
        case 11:
          _context13.prev = 11;
          _context13.t0 = _context13["catch"](0);
          _response13 = _context13.t0.response;
          _context13.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_AMENITY_RESERVATION_FAIL,
            payload: _response13
          });
        case 16:
          _context13.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response13$data = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data !== void 0 ? _response13$data : {}),
              data: _response13
            }
          });
        case 18:
          (0, _utils.logErr)((_response13$data2 = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data2 !== void 0 ? _response13$data2 : {});
        case 19:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 11]]);
  })();
}
function editReservation(_ref27) {
  var payload = _ref27.payload,
    _ref27$callback = _ref27.callback,
    callback = _ref27$callback === void 0 ? _helpers.identity : _ref27$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
    var response, _response14$data, _response14$data2, _response14;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.AmenityService.editReservation, payload);
        case 3:
          response = _context14.sent;
          _context14.next = 6;
          return (0, _effects.put)({
            type: _variables.EDIT_AMENITY_RESERVATION_SUCCESS,
            payload: response
          });
        case 6:
          _context14.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Reservation edited successfully'
            }
          });
        case 8:
          callback();
          _context14.next = 19;
          break;
        case 11:
          _context14.prev = 11;
          _context14.t0 = _context14["catch"](0);
          _response14 = _context14.t0.response;
          _context14.next = 16;
          return (0, _effects.put)({
            type: _variables.EDIT_AMENITY_RESERVATION_FAIL,
            payload: _response14
          });
        case 16:
          _context14.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response14$data = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data !== void 0 ? _response14$data : {}),
              data: _response14
            }
          });
        case 18:
          (0, _utils.logErr)((_response14$data2 = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data2 !== void 0 ? _response14$data2 : {});
        case 19:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 11]]);
  })();
}
function deleteReservation(_ref29) {
  var payload = _ref29.payload,
    _ref29$callback = _ref29.callback,
    callback = _ref29$callback === void 0 ? _helpers.identity : _ref29$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
    var response, _response15$data, _response15$data2, _response15;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.AmenityService.deleteReservation, payload);
        case 3:
          response = _context15.sent;
          _context15.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_AMENITY_RESERVATION_SUCCESS,
            payload: response
          });
        case 6:
          _context15.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Reservation deleted successfully'
            }
          });
        case 8:
          callback();
          _context15.next = 19;
          break;
        case 11:
          _context15.prev = 11;
          _context15.t0 = _context15["catch"](0);
          _response15 = _context15.t0.response;
          _context15.next = 16;
          return (0, _effects.put)({
            type: _variables.DELETE_AMENITY_RESERVATION_FAIL,
            payload: _response15
          });
        case 16:
          _context15.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response15$data = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data !== void 0 ? _response15$data : {}),
              data: _response15
            }
          });
        case 18:
          (0, _utils.logErr)((_response15$data2 = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data2 !== void 0 ? _response15$data2 : {});
        case 19:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 11]]);
  })();
}
function list(_ref31) {
  var payload = _ref31.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
    var response, _response16$data, _response16$data2, _response16;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.AmenityService.list, payload);
        case 3:
          response = _context16.sent;
          _context16.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_SUCCESS,
            payload: response
          });
        case 6:
          _context16.next = 16;
          break;
        case 8:
          _context16.prev = 8;
          _context16.t0 = _context16["catch"](0);
          _response16 = _context16.t0.response;
          _context16.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_FAIL,
            payload: _response16
          });
        case 13:
          _context16.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response16$data = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data !== void 0 ? _response16$data : {}),
              data: _response16
            }
          });
        case 15:
          (0, _utils.logErr)((_response16$data2 = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data2 !== void 0 ? _response16$data2 : {});
        case 16:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 8]]);
  })();
}
function listReservations(_ref33) {
  var payload = _ref33.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
    var response, _response17$data, _response17$data2, _response17;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.AmenityService.listReservations, payload);
        case 3:
          response = _context17.sent;
          _context17.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_RESERVATIONS_SUCCESS,
            payload: response
          });
        case 6:
          _context17.next = 16;
          break;
        case 8:
          _context17.prev = 8;
          _context17.t0 = _context17["catch"](0);
          _response17 = _context17.t0.response;
          _context17.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_RESERVATIONS_FAIL,
            payload: _response17
          });
        case 13:
          _context17.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response17$data = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data !== void 0 ? _response17$data : {}),
              data: _response17
            }
          });
        case 15:
          (0, _utils.logErr)((_response17$data2 = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data2 !== void 0 ? _response17$data2 : {});
        case 16:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 8]]);
  })();
}
function listAcceptedReservations(_ref35) {
  var payload = _ref35.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee18() {
    var response, _response18$data, _response18$data2, _response18;
    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return (0, _effects.call)(_services.AmenityService.listAcceptedReservations, payload);
        case 3:
          response = _context18.sent;
          _context18.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_ACCEPTED_RESERVATIONS_SUCCESS,
            payload: response
          });
        case 6:
          _context18.next = 16;
          break;
        case 8:
          _context18.prev = 8;
          _context18.t0 = _context18["catch"](0);
          _response18 = _context18.t0.response;
          _context18.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_ACCEPTED_RESERVATIONS_FAIL,
            payload: _response18
          });
        case 13:
          _context18.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response18$data = _response18 === null || _response18 === void 0 ? void 0 : _response18.data) !== null && _response18$data !== void 0 ? _response18$data : {}),
              data: _response18
            }
          });
        case 15:
          (0, _utils.logErr)((_response18$data2 = _response18 === null || _response18 === void 0 ? void 0 : _response18.data) !== null && _response18$data2 !== void 0 ? _response18$data2 : {});
        case 16:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[0, 8]]);
  })();
}
function listPendingReservations(_ref37) {
  var payload = _ref37.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
    var response, _response19$data, _response19$data2, _response19;
    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.prev = 0;
          _context19.next = 3;
          return (0, _effects.call)(_services.AmenityService.listPendingReservations, payload);
        case 3:
          response = _context19.sent;
          _context19.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_PENDING_RESERVATIONS_SUCCESS,
            payload: response
          });
        case 6:
          _context19.next = 16;
          break;
        case 8:
          _context19.prev = 8;
          _context19.t0 = _context19["catch"](0);
          _response19 = _context19.t0.response;
          _context19.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_AMENITIES_PENDING_RESERVATIONS_FAIL,
            payload: _response19
          });
        case 13:
          _context19.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response19$data = _response19 === null || _response19 === void 0 ? void 0 : _response19.data) !== null && _response19$data !== void 0 ? _response19$data : {}),
              data: _response19
            }
          });
        case 15:
          (0, _utils.logErr)((_response19$data2 = _response19 === null || _response19 === void 0 ? void 0 : _response19.data) !== null && _response19$data2 !== void 0 ? _response19$data2 : {});
        case 16:
        case "end":
          return _context19.stop();
      }
    }, _callee19, null, [[0, 8]]);
  })();
}
function create(_ref39) {
  var payload = _ref39.payload,
    _ref39$callback = _ref39.callback,
    callback = _ref39$callback === void 0 ? _helpers.identity : _ref39$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee20() {
    var response, _response20$data, _response20$data2, _response20;
    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return (0, _effects.call)(_services.AmenityService.create, payload);
        case 3:
          response = _context20.sent;
          _context20.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_AMENITY_SUCCESS,
            payload: response
          });
        case 6:
          _context20.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity created successfully'
            }
          });
        case 8:
          callback();
          _context20.next = 19;
          break;
        case 11:
          _context20.prev = 11;
          _context20.t0 = _context20["catch"](0);
          _response20 = _context20.t0.response;
          _context20.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_AMENITY_FAIL,
            payload: _response20
          });
        case 16:
          _context20.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response20$data = _response20 === null || _response20 === void 0 ? void 0 : _response20.data) !== null && _response20$data !== void 0 ? _response20$data : {}),
              data: _response20
            }
          });
        case 18:
          (0, _utils.logErr)((_response20$data2 = _response20 === null || _response20 === void 0 ? void 0 : _response20.data) !== null && _response20$data2 !== void 0 ? _response20$data2 : {});
        case 19:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[0, 11]]);
  })();
}
function replenishStock(_ref41) {
  var payload = _ref41.payload,
    _ref41$callback = _ref41.callback,
    callback = _ref41$callback === void 0 ? _helpers.identity : _ref41$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
    var response, _response21$data, _response21$data2, _response21;
    return _regenerator["default"].wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          _context21.next = 3;
          return (0, _effects.call)(_services.AmenityService.replenishStock, payload);
        case 3:
          response = _context21.sent;
          _context21.next = 6;
          return (0, _effects.put)({
            type: _variables.REPLENISH_AMENITY_STOCK_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context21.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Stock increased successfully'
            }
          });
        case 9:
          _context21.next = 19;
          break;
        case 11:
          _context21.prev = 11;
          _context21.t0 = _context21["catch"](0);
          _response21 = _context21.t0.response;
          _context21.next = 16;
          return (0, _effects.put)({
            type: _variables.REPLENISH_AMENITY_STOCK_FAIL,
            payload: _response21
          });
        case 16:
          _context21.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response21$data = _response21 === null || _response21 === void 0 ? void 0 : _response21.data) !== null && _response21$data !== void 0 ? _response21$data : {}),
              data: _response21
            }
          });
        case 18:
          (0, _utils.logErr)((_response21$data2 = _response21 === null || _response21 === void 0 ? void 0 : _response21.data) !== null && _response21$data2 !== void 0 ? _response21$data2 : {});
        case 19:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[0, 11]]);
  })();
}
function debitStock(_ref43) {
  var payload = _ref43.payload,
    _ref43$callback = _ref43.callback,
    callback = _ref43$callback === void 0 ? _helpers.identity : _ref43$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
    var response, _response22$data, _response22$data2, _response22;
    return _regenerator["default"].wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          _context22.next = 3;
          return (0, _effects.call)(_services.AmenityService.debitStock, payload);
        case 3:
          response = _context22.sent;
          _context22.next = 6;
          return (0, _effects.put)({
            type: _variables.DEBIT_AMENITY_STOCK_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context22.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Stock decreased successfully'
            }
          });
        case 9:
          _context22.next = 19;
          break;
        case 11:
          _context22.prev = 11;
          _context22.t0 = _context22["catch"](0);
          _response22 = _context22.t0.response;
          _context22.next = 16;
          return (0, _effects.put)({
            type: _variables.DEBIT_AMENITY_STOCK_FAIL,
            payload: _response22
          });
        case 16:
          _context22.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response22$data = _response22 === null || _response22 === void 0 ? void 0 : _response22.data) !== null && _response22$data !== void 0 ? _response22$data : {}),
              data: _response22
            }
          });
        case 18:
          (0, _utils.logErr)((_response22$data2 = _response22 === null || _response22 === void 0 ? void 0 : _response22.data) !== null && _response22$data2 !== void 0 ? _response22$data2 : {});
        case 19:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[0, 11]]);
  })();
}
function deleteAmenity(_ref45) {
  var payload = _ref45.payload,
    _ref45$callback = _ref45.callback,
    callback = _ref45$callback === void 0 ? _helpers.identity : _ref45$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
    var response, _response23$data, _response23$data2, _response23;
    return _regenerator["default"].wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          _context23.next = 3;
          return (0, _effects.call)(_services.AmenityService["delete"], payload);
        case 3:
          response = _context23.sent;
          _context23.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_AMENITY_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context23.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity deleted successfully'
            }
          });
        case 9:
          _context23.next = 19;
          break;
        case 11:
          _context23.prev = 11;
          _context23.t0 = _context23["catch"](0);
          _response23 = _context23.t0.response;
          _context23.next = 16;
          return (0, _effects.put)({
            type: _variables.DELETE_AMENITY_FAIL,
            payload: _response23
          });
        case 16:
          _context23.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response23$data = _response23 === null || _response23 === void 0 ? void 0 : _response23.data) !== null && _response23$data !== void 0 ? _response23$data : {}),
              data: _response23
            }
          });
        case 18:
          (0, _utils.logErr)((_response23$data2 = _response23 === null || _response23 === void 0 ? void 0 : _response23.data) !== null && _response23$data2 !== void 0 ? _response23$data2 : {});
        case 19:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 11]]);
  })();
}
function get(_ref47) {
  var payload = _ref47.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee24() {
    var response, _response24$data, _response24$data2, _response24;
    return _regenerator["default"].wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.prev = 0;
          _context24.next = 3;
          return (0, _effects.call)(_services.AmenityService.get, payload);
        case 3:
          response = _context24.sent;
          _context24.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_AMENITY_SUCCESS,
            payload: response
          });
        case 6:
          _context24.next = 16;
          break;
        case 8:
          _context24.prev = 8;
          _context24.t0 = _context24["catch"](0);
          _response24 = _context24.t0.response;
          _context24.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_AMENITY_FAIL,
            payload: _response24
          });
        case 13:
          _context24.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response24$data = _response24 === null || _response24 === void 0 ? void 0 : _response24.data) !== null && _response24$data !== void 0 ? _response24$data : {}),
              data: _response24
            }
          });
        case 15:
          (0, _utils.logErr)((_response24$data2 = _response24 === null || _response24 === void 0 ? void 0 : _response24.data) !== null && _response24$data2 !== void 0 ? _response24$data2 : {});
        case 16:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[0, 8]]);
  })();
}
function edit(_ref49) {
  var payload = _ref49.payload,
    _ref49$callback = _ref49.callback,
    callback = _ref49$callback === void 0 ? _helpers.identity : _ref49$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee25() {
    var response, _response25$data, _response25$data2, _response25;
    return _regenerator["default"].wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.prev = 0;
          _context25.next = 3;
          return (0, _effects.call)(_services.AmenityService.edit, payload);
        case 3:
          response = _context25.sent;
          _context25.next = 6;
          return (0, _effects.put)({
            type: _variables.EDIT_AMENITY_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context25.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity edited successfully'
            }
          });
        case 9:
          _context25.next = 19;
          break;
        case 11:
          _context25.prev = 11;
          _context25.t0 = _context25["catch"](0);
          _response25 = _context25.t0.response;
          _context25.next = 16;
          return (0, _effects.put)({
            type: _variables.EDIT_AMENITY_FAIL,
            payload: _response25
          });
        case 16:
          _context25.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response25$data = _response25 === null || _response25 === void 0 ? void 0 : _response25.data) !== null && _response25$data !== void 0 ? _response25$data : {}),
              data: _response25
            }
          });
        case 18:
          (0, _utils.logErr)((_response25$data2 = _response25 === null || _response25 === void 0 ? void 0 : _response25.data) !== null && _response25$data2 !== void 0 ? _response25$data2 : {});
        case 19:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[0, 11]]);
  })();
}
function generateLostStockReport(_ref51) {
  var payload = _ref51.payload,
    _ref51$callback = _ref51.callback,
    callback = _ref51$callback === void 0 ? _helpers.identity : _ref51$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee26() {
    var response, _response26$data, _response26$data2, _response26;
    return _regenerator["default"].wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.prev = 0;
          _context26.next = 3;
          return (0, _effects.call)(_services.AmenityService.generateLostStockReport, payload);
        case 3:
          response = _context26.sent;
          _context26.next = 6;
          return (0, _effects.put)({
            type: _variables.GENERATE_LOST_STOCK_REPORT_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context26.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Amenity lost stock report generated successfully'
            }
          });
        case 9:
          _context26.next = 19;
          break;
        case 11:
          _context26.prev = 11;
          _context26.t0 = _context26["catch"](0);
          _response26 = _context26.t0.response;
          _context26.next = 16;
          return (0, _effects.put)({
            type: _variables.GENERATE_LOST_STOCK_REPORT_FAIL,
            payload: _response26
          });
        case 16:
          _context26.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response26$data = _response26 === null || _response26 === void 0 ? void 0 : _response26.data) !== null && _response26$data !== void 0 ? _response26$data : {}),
              data: _response26
            }
          });
        case 18:
          (0, _utils.logErr)((_response26$data2 = _response26 === null || _response26 === void 0 ? void 0 : _response26.data) !== null && _response26$data2 !== void 0 ? _response26$data2 : {});
        case 19:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[0, 11]]);
  })();
}
function acceptReservation(_ref53) {
  var payload = _ref53.payload,
    _ref53$callback = _ref53.callback,
    callback = _ref53$callback === void 0 ? _helpers.identity : _ref53$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee27() {
    var response, _response27$data, _response27$data2, _response27;
    return _regenerator["default"].wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.prev = 0;
          _context27.next = 3;
          return (0, _effects.call)(_services.AmenityService.acceptReservation, payload);
        case 3:
          response = _context27.sent;
          _context27.next = 6;
          return (0, _effects.put)({
            type: _variables.ACCEPT_RESERVATION_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context27.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Booking accepted successfully'
            }
          });
        case 9:
          _context27.next = 19;
          break;
        case 11:
          _context27.prev = 11;
          _context27.t0 = _context27["catch"](0);
          _response27 = _context27.t0.response;
          _context27.next = 16;
          return (0, _effects.put)({
            type: _variables.ACCEPT_RESERVATION_FAIL,
            payload: _response27
          });
        case 16:
          _context27.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response27$data = _response27 === null || _response27 === void 0 ? void 0 : _response27.data) !== null && _response27$data !== void 0 ? _response27$data : {}),
              data: _response27
            }
          });
        case 18:
          (0, _utils.logErr)((_response27$data2 = _response27 === null || _response27 === void 0 ? void 0 : _response27.data) !== null && _response27$data2 !== void 0 ? _response27$data2 : {});
        case 19:
        case "end":
          return _context27.stop();
      }
    }, _callee27, null, [[0, 11]]);
  })();
}
function rejectReservation(_ref55) {
  var payload = _ref55.payload,
    _ref55$callback = _ref55.callback,
    callback = _ref55$callback === void 0 ? _helpers.identity : _ref55$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee28() {
    var response, _response28$data, _response28$data2, _response28;
    return _regenerator["default"].wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.prev = 0;
          _context28.next = 3;
          return (0, _effects.call)(_services.AmenityService.rejectReservation, payload);
        case 3:
          response = _context28.sent;
          _context28.next = 6;
          return (0, _effects.put)({
            type: _variables.REJECT_RESERVATION_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context28.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Booking rejected successfully'
            }
          });
        case 9:
          _context28.next = 19;
          break;
        case 11:
          _context28.prev = 11;
          _context28.t0 = _context28["catch"](0);
          _response28 = _context28.t0.response;
          _context28.next = 16;
          return (0, _effects.put)({
            type: _variables.REJECT_RESERVATION_FAIL,
            payload: _response28
          });
        case 16:
          _context28.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response28$data = _response28 === null || _response28 === void 0 ? void 0 : _response28.data) !== null && _response28$data !== void 0 ? _response28$data : {}),
              data: _response28
            }
          });
        case 18:
          (0, _utils.logErr)((_response28$data2 = _response28 === null || _response28 === void 0 ? void 0 : _response28.data) !== null && _response28$data2 !== void 0 ? _response28$data2 : {});
        case 19:
        case "end":
          return _context28.stop();
      }
    }, _callee28, null, [[0, 11]]);
  })();
}
function amenityAbility(_ref57) {
  var payload = _ref57.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee29() {
    var response, _response29$data, _response29$data2, _response29;
    return _regenerator["default"].wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.prev = 0;
          _context29.next = 3;
          return (0, _effects.call)(_services.AmenityService.amenityAbility, payload);
        case 3:
          response = _context29.sent;
          _context29.next = 6;
          return (0, _effects.put)({
            type: _variables.AMENITY_ABILITY_SUCCESS,
            payload: response
          });
        case 6:
          _context29.next = 16;
          break;
        case 8:
          _context29.prev = 8;
          _context29.t0 = _context29["catch"](0);
          _response29 = _context29.t0.response;
          _context29.next = 13;
          return (0, _effects.put)({
            type: _variables.AMENITY_ABILITY_FAIL,
            payload: _response29
          });
        case 13:
          _context29.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response29$data = _response29 === null || _response29 === void 0 ? void 0 : _response29.data) !== null && _response29$data !== void 0 ? _response29$data : {}),
              data: _response29
            }
          });
        case 15:
          (0, _utils.logErr)((_response29$data2 = _response29 === null || _response29 === void 0 ? void 0 : _response29.data) !== null && _response29$data2 !== void 0 ? _response29$data2 : {});
        case 16:
        case "end":
          return _context29.stop();
      }
    }, _callee29, null, [[0, 8]]);
  })();
}
function amenityWatcher() {
  return _regenerator["default"].wrap(function amenityWatcher$(_context30) {
    while (1) switch (_context30.prev = _context30.next) {
      case 0:
        _context30.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.AMENITY_ABILITY_REQUEST, amenityAbility), (0, _effects.takeLatest)(_variables.AMENITIES_USAGE_BY_AMENITY_REQUEST, amenitiesByAmenity), (0, _effects.takeLatest)(_variables.AMENITIES_USAGE_BY_DAY_REQUEST, amenitiesByDay), (0, _effects.takeLatest)(_variables.LIST_PENDENT_CHECKOUTS_REQUEST, listPendentCheckouts), (0, _effects.takeLatest)(_variables.CHECKOUT_REQUEST, checkout), (0, _effects.takeLatest)(_variables.LIST_AMENITIES_REQUEST, list), (0, _effects.takeLatest)(_variables.LIST_AMENITIES_RESERVATIONS_REQUEST, listReservations), (0, _effects.takeLatest)(_variables.LIST_AMENITIES_ACCEPTED_RESERVATIONS_REQUEST, listAcceptedReservations), (0, _effects.takeLatest)(_variables.LIST_AMENITIES_PENDING_RESERVATIONS_REQUEST, listPendingReservations), (0, _effects.takeLatest)(_variables.CREATE_AMENITY_REQUEST, create), (0, _effects.takeLatest)(_variables.GET_AMENITY_REQUEST, get), (0, _effects.takeLatest)(_variables.EDIT_AMENITY_REQUEST, edit), (0, _effects.takeLatest)(_variables.CREATE_AMENITY_RESERVATION_REQUEST, createReservation), (0, _effects.takeLatest)(_variables.LIST_AMENITIES_ENTRIES_REQUEST, listEntries), (0, _effects.takeLatest)(_variables.LIST_AMENITIES_BLOCKS_REQUEST, listBlocks), (0, _effects.takeLatest)(_variables.REPLENISH_AMENITY_STOCK_REQUEST, replenishStock), (0, _effects.takeLatest)(_variables.DEBIT_AMENITY_STOCK_REQUEST, debitStock), (0, _effects.takeLatest)(_variables.LIST_AMENITIES_STOCK_MOVEMENT_REQUEST, listStockMovement), (0, _effects.takeLatest)(_variables.EDIT_AMENITY_RESERVATION_REQUEST, editReservation), (0, _effects.takeLatest)(_variables.DELETE_AMENITY_RESERVATION_REQUEST, deleteReservation), (0, _effects.takeLatest)(_variables.DELETE_AMENITY_REQUEST, deleteAmenity), (0, _effects.takeLatest)(_variables.GET_DAY_AVAILABILITY_REQUEST, listDayAvailability), (0, _effects.takeLatest)(_variables.GET_MONTH_AVAILABILITY_REQUEST, listMonthAvailability), (0, _effects.takeLatest)(_variables.GET_RESERVATION_END_PERIODS_REQUEST, listReservationEndPeriods), (0, _effects.takeLatest)(_variables.BLOCK_AMENITY_REQUEST, blockAmenity), (0, _effects.takeLatest)(_variables.FINISH_AMENITY_ENTRY_REQUEST, finishEntry), (0, _effects.takeLatest)(_variables.GENERATE_LOST_STOCK_REPORT_REQUEST, generateLostStockReport), (0, _effects.takeLatest)(_variables.ACCEPT_RESERVATION_REQUEST, acceptReservation), (0, _effects.takeLatest)(_variables.REJECT_RESERVATION_REQUEST, rejectReservation)]);
      case 2:
      case "end":
        return _context30.stop();
    }
  }, _marked);
}